import React from "react";

const Footer = () => {
    return (
        // footer
        <div className="footer-area">
            <div className="container">
                <div className="row">
                    <div className="col-lg-3 col-md-6">
                        <div className="footer-box about-widget">
                            <h2 className="widget-title">About Farmers Marketspace</h2>
                            <p>Farmers Marketspace connects local farms directly to your table. We deliver fresh, seasonal produce and artisanal goods from trusted local producers, supporting sustainable agriculture and healthy communities. Taste the difference of local!</p>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6">
                        <div className="footer-box get-in-touch">
                            <h2 className="widget-title">Get in Touch</h2>
                            <ul>
                                <li>team@farmersmarketspace.com</li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6">
                        <div className="footer-box pages">
                            <h2 className="widget-title">Pages</h2>
                            <ul>
                                <li><a href="/">Home</a></li>
                                <li><a href="/shop">Shop</a></li>
                                <li><a href="/cart">Cart</a></li>
                                <li><a href="/pickup-location">Pickup Location</a></li>
                                <li><a href="/producers">Producers</a></li>
                                {/* Membership tab temporarily hidden */}
                                {/* <li><a href="/membership">Membership</a></li> */}
                                {/* <li><a href="about.html">About</a></li>
                                <li><a href="contact.html">Contact</a></li> */}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Footer;